import React, { Component } from "react";
import { TextField, FormHelperText, InputLabel, MenuItem, Select, FormControl } from '@material-ui/core';
import TextInputField from '../atoms/text-input-field'

class PlacesAutocomplete extends Component {
  constructor(props) {
    super(props)
    this.state = {
        elements: this.props.elements,
        street: '',
        street2: '',
        city: '',
        state: '',
        zip: ''
    }

    this.handlePlaceSelect = this.handlePlaceSelect.bind(this)
    this.handleChange = this.handleChange.bind(this)
    this.autocomplete = null
  }

  componentDidMount() {
    const google = window.google;
    const options = {
        componentRestrictions: { country: "us" },
        fields: ["address_components"],
    };
    this.autocomplete = new google.maps.places.Autocomplete(document.getElementById('autocomplete'), options);
    this.autocomplete.addListener("place_changed", this.handlePlaceSelect)
  }

  handleChange(event) {
    this.setState({[event.target.name]: event.target.value})
  }

  handlePlaceSelect() {
    let streetNumber, streetAddress, city, state, zip;
    let getAddressObj = this.autocomplete.getPlace();
    let addressObj = getAddressObj.address_components;

    addressObj.map((item, index) => {
        item.types.map((type, index) => {
            if(type === "street_number") {
                streetNumber = item.long_name;
            }
            if(type === "route") {
                streetAddress = item.long_name;
            }
            if(type === "locality") {
                city = item.long_name;
            }
            if(type === "administrative_area_level_1") {
                state = item.short_name;
            }
            if(type === "postal_code") {
                zip = item.short_name;
            }
        })
    })


    this.setState({
      street: `${streetNumber} ${streetAddress}`,
      city: city,
      state: state,
      zip: zip
    })
  }

  render() {
    const createClassList = () => {
        let classList = 'ca-places-autocomplete';
        if (this.props.className) classList = classList + ' ca-places-autocomplete--' + this.props.className;
        if (this.props.classNameJS) classList = classList + ' ' + this.props.classNameJS;
        // if (isRequired) classList = classList + ' js-required';
        return classList;
    };

    const getStates = () => {
        const states = [
            {
                "name": "State",
                "value": "",
                "disabled": true,
                "selected": true
            },
            {
                "name": "Alabama",
                "value": "AL"
            },
            {
                "name": "Alaska",
                "value": "AK"
            },
            {
                "name": "Arizona",
                "value": "AZ"
            },
            {
                "name": "Arkansas",
                "value": "AR"
            },
            {
                "name": "California",
                "value": "CA"
            },
            {
                "name": "Colorado",
                "value": "CO"
            },
            {
                "name": "Connecticut",
                "value": "CT"
            },
            {
                "name": "Delaware",
                "value": "DE"
            },
            {
                "name": "District Of Columbia",
                "value": "DC"
            },
            {
                "name": "Florida",
                "value": "FL"
            },
            {
                "name": "Georgia",
                "value": "GA"
            },
            {
                "name": "Hawaii",
                "value": "HI"
            },
            {
                "name": "Idaho",
                "value": "ID"
            },
            {
                "name": "Illinois",
                "value": "IL"
            },
            {
                "name": "Indiana",
                "value": "IN"
            },
            {
                "name": "Iowa",
                "value": "IA"
            },
            {
                "name": "Kansas",
                "value": "KS"
            },
            {
                "name": "Kentucky",
                "value": "KY"
            },
            {
                "name": "Louisiana",
                "value": "LA"
            },
            {
                "name": "Maine",
                "value": "ME"
            },
            {
                "name": "Maryland",
                "value": "MD"
            },
            {
                "name": "Massachusetts",
                "value": "MA"
            },
            {
                "name": "Michigan",
                "value": "MI"
            },
            {
                "name": "Minnesota",
                "value": "MN"
            },
            {
                "name": "Mississippi",
                "value": "MS"
            },
            {
                "name": "Missouri",
                "value": "MO"
            },
            {
                "name": "Montana",
                "value": "MT"
            },
            {
                "name": "Nebraska",
                "value": "NE"
            },
            {
                "name": "Nevada",
                "value": "NV"
            },
            {
                "name": "New Hampshire",
                "value": "NH"
            },
            {
                "name": "New Jersey",
                "value": "NJ"
            },
            {
                "name": "New Mexico",
                "value": "NM"
            },
            {
                "name": "New York",
                "value": "NY"
            },
            {
                "name": "North Carolina",
                "value": "NC"
            },
            {
                "name": "North Dakota",
                "value": "ND"
            },
            {
                "name": "Ohio",
                "value": "OH"
            },
            {
                "name": "Oklahoma",
                "value": "OK"
            },
            {
                "name": "Oregon",
                "value": "OR"
            },
            {
                "name": "Pennsylvania",
                "value": "PA"
            },
            {
                "name": "Rhode Island",
                "value": "RI"
            },
            {
                "name": "South Carolina",
                "value": "SC"
            },
            {
                "name": "South Dakota",
                "value": "SD"
            },
            {
                "name": "Tennessee",
                "value": "TN"
            },
            {
                "name": "Texas",
                "value": "TX"
            },
            {
                "name": "Utah",
                "value": "UT"
            },
            {
                "name": "Vermont",
                "value": "VT"
            },
            {
                "name": "Virginia",
                "value": "VA"
            },
            {
                "name": "Washington",
                "value": "WA"
            },
            {
                "name": "West Virginia",
                "value": "WV"
            },
            {
                "name": "Wisconsin",
                "value": "WI"
            },
            {
                "name": "Wyoming",
                "value": "WY"
            }
        ]
        let optionFields = states.map((option, index) => (
            <MenuItem value={option.value} disabled={option.disabled ? 'disabled' : null} key={index}>{option.name}</MenuItem>
        ));
        return optionFields;
    }


    return(
        <div className={createClassList()} data-button-id={this.props.buttonID}>
            <div className='ca-text-input-field js-required'>
                <div className='ca-text-input-field__wrapper'>
                    <TextField 
                        id="autocomplete" 
                        variant="outlined"
                        name="street"
                        placeholder="Street address"
                        value={this.state.street}
                        required={true}
                        autoComplete="off"
                        data-save={true}
                        data-value-type="streetAddress"
                        onChange={this.handleChange}
                        helperText="Please enter a valid street address"
                        label="Street address"
                    />
                </div>
            </div>
            <div className='ca-text-input-field js-required'>
                <div className='ca-text-input-field__wrapper'>
                    <TextField 
                        variant="outlined"
                        name="street2"
                        placeholder="Apartment, suite, etc. (optional)"
                        value={this.state.street2}
                        required={false}
                        autoComplete="off"
                        data-save={true}
                        data-value-type="streetAddress2"
                        onChange={this.handleChange}
                        label="Apartment, suite, etc. (optional)"
                    />
                </div>
            </div>
            <div className='ca-text-input-field js-required'>
                <div className='ca-text-input-field__wrapper'>
                    <TextField 
                        variant="outlined"
                        name="city"
                        placeholder="City"
                        value={this.state.city}
                        required={true}
                        autoComplete="off"
                        data-save={true}
                        data-value-type="city"
                        onChange={this.handleChange}
                        helperText="Please enter a valid city"
                        label="City"
                    />
                </div>
            </div>
            <div className="ca-select-field js-required">
                <FormControl>
                    <InputLabel id="demo-simple-select-helper-label">State *</InputLabel>
                    <Select
                        variant="outlined"
                        labelId="demo-simple-select-helper-label"
                        id="demo-simple-select-helper"
                        value={this.state.state}
                        label="State *"
                        name="state"
                        required={true}
                        onChange={this.handleChange}
                    >
                        {getStates()}
                    </Select>
                    <FormHelperText>Please enter a valid state</FormHelperText>
                </FormControl>
            </div>
            <div className='ca-text-input-field js-required'>
                <div className='ca-text-input-field__wrapper'>
                    <TextField 
                        variant="outlined"
                        name="zip"
                        placeholder="Zip code"
                        value={this.state.zip}
                        required={true}
                        autoComplete="off"
                        data-save={true}
                        data-value-type="zip"
                        onChange={this.handleChange}
                        helperText="Please enter a valid zip code"
                        label="Zip code"
                        inputProps={{"pattern": "[0-9]*"}}
                    />
                </div>
            </div>
        </div>
    )
  }

}

export default PlacesAutocomplete